// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query CobraFont  {\naccountInt  {\n__typename\nfont  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.accountInt;
  var value$2 = value$1.font;
  var tmp;
  switch (value$2) {
    case "AUS_NSW_ACT" :
        tmp = "AUS_NSW_ACT";
        break;
    case "AUS_QLD" :
        tmp = "AUS_QLD";
        break;
    case "AUS_SA" :
        tmp = "AUS_SA";
        break;
    case "AUS_TAS" :
        tmp = "AUS_TAS";
        break;
    case "AUS_VIC_NT_WA" :
        tmp = "AUS_VIC_NT_WA";
        break;
    case "KGNEATLY" :
        tmp = "KGNEATLY";
        break;
    case "NOT_SET" :
        tmp = "NOT_SET";
        break;
    case "NZ_DEFAULT" :
        tmp = "NZ_DEFAULT";
        break;
    case "SASSOON_SANS_US_REG" :
        tmp = "SASSOON_SANS_US_REG";
        break;
    default:
      throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
          };
  }
  return {
          accountInt: {
            font: tmp
          }
        };
}

function serialize(value) {
  var value$1 = value.accountInt;
  var value$2 = value$1.font;
  var font = value$2 === "NOT_SET" ? "NOT_SET" : (
      value$2 === "KGNEATLY" ? "KGNEATLY" : (
          value$2 === "AUS_NSW_ACT" ? "AUS_NSW_ACT" : (
              value$2 === "SASSOON_SANS_US_REG" ? "SASSOON_SANS_US_REG" : (
                  value$2 === "AUS_QLD" ? "AUS_QLD" : (
                      value$2 === "AUS_TAS" ? "AUS_TAS" : (
                          value$2 === "NZ_DEFAULT" ? "NZ_DEFAULT" : (
                              value$2 === "AUS_SA" ? "AUS_SA" : "AUS_VIC_NT_WA"
                            )
                        )
                    )
                )
            )
        )
    );
  var accountInt = {
    font: font
  };
  return {
          accountInt: accountInt
        };
}

function serializeVariables() {
  
}

function makeVariables() {
  
}

function makeDefaultVariables() {
  
}

var CobraFontQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var CobraFontQuery = {
  CobraFontQuery_inner: CobraFontQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  use: use,
  useFetch: useFetch
};

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function CobraFontQuery$1(props) {
  var match = React.useState(function () {
        
      });
  var setFont = match[1];
  var $$fetch = Q.useAsync();
  React.useEffect((function () {
          var q = async function (param) {
            var res = await $$fetch();
            return Belt_Option.map(res, (function (param) {
                          var accountInt = param.accountInt;
                          setFont(function (param) {
                                return accountInt.font;
                              });
                        }));
          };
          q();
        }), []);
  return props.children(match[0]);
}

var make = CobraFontQuery$1;

export {
  CobraFontQuery ,
  Q ,
  make ,
}
/* query Not a pure module */
